import { useMemo } from 'react';
import { useContractSpaceInfos } from '../../hooks/use-space-data';
import { useOfflineStore } from '../../store/use-offline-store';
export function useCasablancaSpaces(opts, spaceIds, casablancaClient) {
    const { data: spaceInfos } = useContractSpaceInfos(opts, spaceIds, casablancaClient);
    const { offlineSpaceInfoMap: spaceNamesInLocalStore } = useOfflineStore();
    return useMemo(() => {
        const streams = spaceIds.map((streamId) => {
            const spaceName = spaceInfos?.find((i) => i.networkId == streamId)?.name ??
                spaceNamesInLocalStore[streamId]?.name ??
                '';
            return {
                id: streamId,
                name: spaceName,
                avatarSrc: '',
            };
        });
        return streams;
    }, [spaceIds, spaceInfos, spaceNamesInLocalStore]);
}
//# sourceMappingURL=useCasablancaSpaces.js.map